import { ShieldOff } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function AccessDenied() {
  const navigate = useNavigate()
  return (
    <div className="flex flex-col items-center justify-center h-64 text-center p-8">
      <div className="w-16 h-16 rounded-full bg-error/10 flex items-center justify-center mb-4">
        <ShieldOff className="w-8 h-8 text-error" />
      </div>
      <h2 className="text-xl font-bold text-text-primary mb-2">Erişim Reddedildi</h2>
      <p className="text-sm text-text-secondary max-w-md mb-6">
        Bu sayfayı görüntüleme yetkiniz bulunmuyor.
      </p>
      <button
        onClick={() => navigate(-1)}
        className="inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-lg bg-bg-elevated text-text-primary hover:bg-bg-border transition-colors"
      >
        Geri Dön
      </button>
    </div>
  )
}
